import React, { useMemo } from "react";
import { formatDisplayDate } from "helpers/calendar/calendarDates";
import { buildUpcomingList } from "helpers/calendar/calendarTerms";

const ListView = ({ config, onSelectDay }) => {
  const items = useMemo(() => buildUpcomingList(config), [config]);

  if (items.length === 0) {
    return (
      <p className="calendar-list__empty">
        No upcoming closures or auto-draft dates on the calendar.
      </p>
    );
  }

  return (
    <ol className="calendar-list" aria-label="Upcoming closures and auto-draft dates">
      {items.map((item) => (
        <li key={`${item.type}-${item.date.toISOString()}`}>
          <button
            type="button"
            className={`calendar-list__item calendar-list__item--${item.type}`}
            onClick={() => onSelectDay?.(item.date, { ...item, isClosed: item.type === "closed", isAutoDraft: item.type === "autoDraft", term: item.term })}
          >
            <span className="calendar-list__date">
              {formatDisplayDate(item.date)}
            </span>
            <span className="calendar-list__meta">
              <span className="calendar-list__badge">{item.label}</span>
              {item.term && (
                <span className="calendar-list__term">{item.term.name}</span>
              )}
            </span>
          </button>
        </li>
      ))}
    </ol>
  );
};

export default ListView;
